import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BursaAPIOrderResult from './bursa-api-order-result';
import BursaAPIOrderResultDetail from './bursa-api-order-result-detail';
import BursaAPIOrderResultUpdate from './bursa-api-order-result-update';
import BursaAPIOrderResultDeleteDialog from './bursa-api-order-result-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BursaAPIOrderResultUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BursaAPIOrderResultUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BursaAPIOrderResultDetail} />
      <ErrorBoundaryRoute path={match.url} component={BursaAPIOrderResult} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={BursaAPIOrderResultDeleteDialog} />
  </>
);

export default Routes;
